import { Component, OnInit, NgZone , OnDestroy} from '@angular/core';
import {CartService} from '../../../services/cart.service';
import {Cartitems2} from '../../../classes/cartitems';
// import { MaterialModule } from '@angular/material';
import {Shipping} from '../../../classes/shipping';
import {Billing} from '../../../classes/billing';
import { RazorpayService } from '../../../PaymentGateway/razorpay/razorpay.service';
import {Orderitems} from '../../../classes/orderitems';
import {Order} from '../../../classes/order';
import { Ordertype} from '../../../classes/order';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import {Inventories} from '../../../classes/inventories';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute,Params } from '@angular/router';
import {CommonService} from '../../../services/common.service';
import { Cityinventory } from '../../../classes/invcheck';
import { MatDialog, MatDialogRef } from '@angular/material';
import { DoctorService } from '../../../services/doctor.service';
import {Observable} from 'rxjs/rx';
@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit , OnDestroy {
  razoid: any;
  deliverycharge: number;
  pay: number;
  payable1: number;
  timer: any;
  subscription: any;
  cartflag = 0;
  invStock = [];
  cartlength: number;
  paymentstatus: any;
  payment_stats= 'pending';
  ipadd: any;
  source: any;
  state: string;
  country: string;
  city: string;
  action: any;
  msg1: any;
  totalitems: number;
  public data: Cartitems2[];
  dataship: Shipping[];
  billship: Billing[];
  orderitem: Orderitems[];
  ordertype: Ordertype[];
  orders: any;
  invstock = 1;
  subtotal = 0;
  totaldiscount = 0;
  items: number;
  payable = 0;
  isdefault = 0;
  userid: any;
  username: any;
  uid: number;
  gdata: any;
  gjson: any;
  uemail: any;
  umobile: any;
  shippingmode = ['free', 'rs99'];
  ssid: any;
  payment = [ 'Razorpay (All Card / Net Banking)', 'Cash on Delivery', 'Card on Delivery', 'Pay by Paytm App on Delivery',
  'UltraCash App'];
  /* Order*/
  rstring: string;
  orderid: string;
  shippingaddid: number;
  billingaddid: number;
  payment_mode: string;
  shipping_mode: string;
  prod_name: string;
  prod_id: number;
  sku: string;
  mrp: number;
  discount: number;
  discprice: number;
  quantity: number;
  tax: number;
  payable2: number;
  totalmrp = 0;
  totaltax = 0;
  totaldiscount2 = 0;
  totalpayable = 0;
  orderstatus_id = 1;
  date: any;
  store_id: any;
  order_type: any;
  city_id: number;
  public loading = false;
  private paymentid: any;
  public razorpayorderplacedflag = 0;
  public orderplacedflag = 0;
  timer1: any;
  counter = 5;
  constructor(private cartService: CartService, private router: Router,
    private commonService: CommonService, private snackbar: MatSnackBar, private doctorservice: DoctorService,
  private dialog: MatDialog, private razorpayService: RazorpayService, private zone: NgZone) {
    this.commonService.setMenuFlag(1);
    this.city_id = 1;
    this.timer1 = setInterval(() => this.timedelay(), 1000)
    this.getDate();
    this.order_type = 0;
    this.cartService.totalcartitems.subscribe(totalcartitems => {
      this.totalitems = totalcartitems
    });

    this.razorpayService.paymentstatus.subscribe(ps => {
      this.paymentstatus = ps;

      if (this.paymentstatus === 1) {
        this.nextAction();
      }
      if (this.paymentstatus === 2) {
        this.paymentCancelled();
      }
    });

    /*this.commonService.getIpAddress()
    .subscribe(
      (x) => {

          this.ipadd = x.ip;


      });*/

      this.source = 'WebApp';
  }

  ngOnInit() {
    this.timer = Observable.timer(2000, 5000);
    this.subscription = this.timer.subscribe(() => this.runzone());
    this.loading = true;
  }
  timedelay() {
    this.counter = this.counter  - 1;
    if (this.counter === 0) {
      clearInterval(this.timer1);
      const udata = this.commonService.getUserDataLocally();
      this.userid = udata.uid;
      this.username = udata .uname;
      this.uemail = udata.uemail;
      this.umobile = udata.umobile;
      this. getUserBillingAddress();
      this.cartService.getUserdefaultAddress(this.userid)
      .subscribe(
        (dataship: Shipping[]) => {
          this.dataship = dataship;
          this.setname();
        });
      this.cartService.getUserCartItems(this.userid)
      .subscribe(
        (data: Cartitems2[]) => {
          this.loading = false;
          this.data = data;
          this.cartlength = this.data.length;
          if (this.data.length > 0) {
            this.count();
          }else {
            this.msg1 = 'No item Added in Your cart. So please buy something and come here';
            this.openSnackBar();
            this.router.navigate(['/store/cart']);
          }
        }
        );
         
       

    }
  }
  getUserBillingAddress() {
    this.cartService.getUserBillingAddress(this.userid)
    .subscribe(
     (billship: Billing[]) => {
        this.billship = billship;
        this.setname2();
      });
  }
  count() {
    for (let i = 0; i < this.data.length; i++) {
      this.subtotal = this.subtotal + this.data[i].mrp;
      this.totaldiscount = this.totaldiscount + (this.data[i].discount * this.data[i].quantity);
      this.payable = this.payable +  this.data[i].payable;
      if ( this.payable >= 500) {
        this.shipping_mode = 'Free Shipping for Orders over Rs. 500';
      }else {
        this.shipping_mode = 'Rs. 99 for Orders below Rs. 500'

      }
    }
    if(this.shipping_mode === 'Rs. 99 for Orders below Rs. 500'){
      this.pay =  this.payable + 99;
      this.deliverycharge = 99;
    } else {
      this.pay =  this.payable ;
      this.deliverycharge = 0;
    }

    this.firstCheck();
  }
firstCheck() {
  this.loading = true;
  this.cartflag = 0;
  this.invStock = [];
  this.getinvstatusFirstTime();
}
getinvstatusFirstTime() {
  let cartlencount = this.data.length;
  for ( let i = 0 ; i < this.data.length; i ++) {
    this.commonService.getInventoryDetails(this.data[i].product_id, this.city_id)
    .subscribe(
      (x) => {
        this.invStock.push(x[0]);
        cartlencount = cartlencount - 1;
        if (cartlencount === 0) {
          this.loading = false;
          this.checkposibilityFirstTime();
        }
      });
  }
}
checkposibilityFirstTime() {
  for (let j = 0 ; j < this.data.length ; j++) {
    for (let i = 0 ; i < this.invStock.length ; i++) {
     if (this.data[j].product_id === this.invStock [i] .product_id
    && (this.data[j].quantity > this.invStock[i]. totalstock || this.invStock[i].status === 0)) {
      const extra =  this.invStock[i]. totalstock;
      const status = this.invStock[i].status;
      console.log(this.invStock[i].status);
      this.cartflag = this.cartflag + 1;
    }
  }
 }
 if (this.cartflag > 0) {
  this.msg1 = 'We Have some Limited Stock For your item. So please modify your cart and try again';
  this.openSnackBar();
  this.router.navigate(['/store/cart'])
 }
}
setname() {
  for ( let i = 0; i < this.dataship.length; i++) {
    if ( this.dataship && this.dataship[i].city_id == 1) {
      this.city = 'Banglore';
      this.country = 'India';
      this.state = 'Karnataka';
    }
  }
}
setname2() {
  if (this.billship && this.billship.length > 0) {
    if ( this.billship[0].city_id == 1) {
      this.city = 'banglore';
      this.country = 'India';
      this.state = 'India';
    }
  }

}
BackToCart() {
  this.router.navigate(['/store/cart'])
}

placeOrder() {
  this.cartlength = this.data.length;
  if (this.dataship && this.dataship.length == 0) {
    alert('shipping address not added');
    }
  if (this.billship && this.billship.length == 0) {
    alert('Billing address not added');
    }
  if (!this.shipping_mode) {
    alert('please select shipping mode');
    }
  if (!this.payment_mode) {
    alert('please select payment mode');
    }
  if (this.dataship && this.dataship.length !== 0 && this.billship &&
    this.shipping_mode && this.billship.length !== 0 && this.payment_mode) {
    this.loading = true;
    let m = 0;
    this.invstock = 0;
    if (this.data.length > 0) {
      for (let i = 0; i < this.data.length; i++) {
        this.cartlength = this.cartlength - 1;
        m = this.data[i].quantity;
        this.commonService.getInventoryDetails(this.data[i].product_id, this.city_id)
        .subscribe(
          (x: Cityinventory[]) => {
            if (x[0].status === 0 && x[0].totalstock === 0) {
              this.invstock = this.invstock + 1;
            }else if (x[0].totalstock < m && x[0].status === 1) {
              this.invstock = this.invstock + 1;
            }
            if (this.cartlength === 0) {
              this.successfulInventorycheck();
            }
          });
      }
    } else {
      this.msg1 = 'User Cart is Empty.  No Product For To Generate Order';
      this.openSnackBar();
    }
  }
}
successfulInventorycheck() {
  this.cartlength = this.data.length;
  if (this.invstock === 0) {
    this.rstring = this.randomString();
    const str1 =  'BLE' ;
    this.orderid = str1 + this.userid + this.rstring;
    this.razoid = this.orderid;
    if(this.razoid.length < 20) {
      this.razoid = '_' + this.razoid;
      var len = this.razoid.length;
    }
    for (let i = len; i < 20; i++) {
      console.log(i);
      if (this.razoid.length < 20) {
        // tslint:disable-next-line:no-unused-expression
        this.razoid = '0' + this.razoid ;
      }
    }

   /* for(let i = 0; i < this.orderid.length; i++){
      if(this.orderid.length < 20) {
        // tslint:disable-next-line:no-unused-expression
        this.razoid = this.orderid + '0';
      }
    }*/
   
    this.billingaddid = this.billship[0].id;
    for (let i = 0; i < this.dataship.length; i++) {
      if (this.dataship[i].isdefault === 1) {
        this.shippingaddid = this.dataship[i].id;
      }
    }

    for (let i = 0; i < this.data.length; i++) {
      this.prod_name = this.data[i].product_name ;
      this.prod_id = this.data[i].product_id ;
      this.tax = this.data[i].tax ;
      this.sku = this.data[i].sku ;
      this.mrp = this.data[i].mrp ;
      this.discount = this.data[i].discount ;
      this.discprice = this.data[i].discprice ;
      this.quantity = this.data[i].quantity ;

      this.payable2 = this.data[i].payable ;
      this.totalmrp = this.totalmrp + (this.mrp * this.quantity) ;
      this.totaltax = this.totaltax + this.tax;
      this.totaldiscount2 = this.totaldiscount2 + (this.discount * this.quantity);
      this.totalpayable = this.totalpayable + this.payable2;

      this.cartService.generateOrderItems(this.orderid,this.prod_id,this.prod_name,this.sku,this.mrp,
        this.discount,this.discprice,this.quantity,this.payable2,this.tax)
      .subscribe(
        (orderitem: Orderitems[]) => {
          this.orderitem = orderitem;
          this.cartlength = this.cartlength - 1;
          if (this.cartlength === 0) {
            this.placeOrderFinally();
          }
        }); 
    }
  } else if (this.invstock > 0) {
    this.loading = false;
    this.msg1 = 'We have some item sort for your order. please modify your cart and try again';
    this.BackToCart();
    this.openSnackBar();
    }
  }
placeOrderFinally() {
  this.store_id = 0;
  this.cartService.placeOrderType(this.orderid, this.billship[0].city_id, this.store_id,
    this.order_type)
  .subscribe(
    (ordertype: Ordertype[]) => this.ordertype = ordertype,
    );
    if(this.totalpayable < 500){
      this.totalpayable = this.totalpayable + 99;
    }
    if (this.ipadd === undefined) {
      this.ipadd = '0.0.0.0' ;
    }


    this.cartService.placeOrder(this.orderid, this.date, this.userid, this.username, this.totalmrp,
      this.totaltax, this.totaldiscount2, this.totalpayable, this.shipping_mode, this.payment_mode , this.payment_stats,
      this.umobile, this.uemail,
      this.orderstatus_id, this.billingaddid, this.shippingaddid, this.ipadd, this.source)
    .subscribe(
      (x) => {
        this.orders = x;
        window.scrollTo(0, 0);
        // this.changeStockEffect();
        this.deleateAllCartItems();
      });
}
changeStockEffect() {
  this.cartlength = this.data.length;
   for ( let i = 0 ; i < this.data.length ; i++ ) {
    this.commonService.getInventoryDetails(this.data[i].product_id, this.city_id)
    .subscribe(
      (x) => {
        const id = x[0].id;
        let astock = x[0].actualstock;
        const qty = this.data[i].quantity;
        astock = astock - qty;
        const tstock = astock + x[0].virtualstock;
        if (tstock === 0) {
          this.updateInventoryWithStatus(id, astock, tstock)
        } else {
          this.updateInventoryWithoutStatus(id, astock, tstock)
        }
      })
   }
}
updateInventoryWithStatus(id, astock, tstock) {
  const status = 0;
  this.commonService.updateStockWithStatus(id, astock , tstock, status )
  .subscribe(
    (x) => {
      this.cartlength = this.cartlength - 1;
      if (this.cartlength === 0) {
        this.deleateAllCartItems();
      }
    });
}
updateInventoryWithoutStatus(id, astock, tstock) {
  this.commonService.updateStockWithoutStatus(id, astock , tstock)
  .subscribe(
    (x) => {
      this.cartlength = this.cartlength - 1;
      if (this.cartlength === 0) {
        this.deleateAllCartItems();
      }
    });
}
randomString() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
  const string_length = 5;
  let randomstring = '';
  for (let i = 0; i < string_length; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}
deleateAllCartItems() {
  this.cartlength = this.data.length;
  for (let i = 0; i < this.data.length; i++) {
    this. myCartRemoveMethod(this.data[i].id);
  }
}
myCartRemoveMethod(id) {
  this.cartService.deleteCart(id)
  .subscribe(
    () => {
      this.cartlength = this.cartlength - 1;
      if (this.cartlength === 0) {
        this.compareLoop();
      }
    });
}
compareLoop() {
  this.cartService.changeTotalCartItems(0);
    this.loading = false;
    if (this.payment_mode === 'Razorpay (All Card / Net Banking)') {
      this.openRazorpay();
    } else {
     // this.orderplacedflag = 1;
      this.router.navigate(['/store/orderplaced']);
    }
}

openRazorpay() {
  var type= 'ecom';
  this.razorpayService.createtransaction(this.username, this.uemail, this.umobile, this.totalpayable, this.razoid, type)
}
private nextAction() {
  this.loading = true;
  this.paymentid = this.razorpayService.getPaymentId();
  if(this.paymentid !== undefined){
    console.log('In nextAction', this.paymentid, this.totalpayable);
    const order_type = 'Order';
    this.razorpayService.initiateTransaction(this.userid, this.paymentid, this.totalpayable,
       this.orders.orderno, order_type )
    .subscribe(
      (x) => {
        this.razorpayService.managestatus.next(0);

        this.updateStatus();
      });
  } else {
    this.loading = false;
    this.router.navigate(['/store/orderplaced']);
  /*  this.zone.run(() => {
      this.razorpayorderplacedflag = 1;
      }); */
  }

    // this.updateStatus();
}
private paymentCancelled() {
  this.loading = false;
  this.orderplacedflag = 2;
 
  this.router.navigate(['/manageprofile/orderdetail/' + this.orderid]);
}
updateStatus() {

//  this.loading = true;
  const payment_id = 'complete';
this.cartService.changeOrderstatus(this.orders.id, payment_id)
.subscribe(
  (x) => {
    console.log('in update status', x);
  this.loading = false;
  this.router.navigate(['/store/orderplaced']);
 /* this.zone.run(() => {
    this.loading = false;
  this.razorpayorderplacedflag = 1;
  }); */
});
}

goToOrder() {
  this.router.navigate(['/manageprofile/order']);
}

runzone() {
  this.zone.run(() => {
    if (this.razorpayorderplacedflag === 1) {
     // this.orderplacedflag = 1;
      this.router.navigate(['/store/orderplaced']);
    }
  });
}

getDate() {
  this.doctorservice.getTime()
  .subscribe(
    (d) => {
      const ctime = d.date;
      const css = ctime.date
      const stringarr = css.toString().toLowerCase().split(' ');
      this.date = stringarr[0];
    });
}

ChangeCartItemsFlag(){
  let total = 0;
 // this.cartService.totalcartitems.next(total);
 this.cartService.changeTotalCartItems(total);
}

openSnackBar() {
  this.snackbar.open(this.msg1 , this.action, {
    duration: 4000,
  });
}
cancelOrder() {
  this.loading = true;
  this.cartlength = this.data.length;
  for (let i = 0; i < this.data.length; i++) {
    this. myCartRemoveMethod2(this.data[i].id);
  }
}
myCartRemoveMethod2(id) {
  this.cartService.deleteCart(id)
  .subscribe(
    () => {
      this.cartlength = this.cartlength - 1;
      if (this.cartlength === 0) {
        this.compareLoop2();
      }
    });
}
compareLoop2() {
  this.cartService.changeTotalCartItems(0);
  this.loading = false;
  this.msg1 = 'All items has been removed from your cart';
  this.openSnackBar();
   this.router.navigate(['/store/home']);
}
changeAddress() {
  this.router.navigate(['/store/useraddress']);
}
ngOnDestroy() {
  this.subscription.unsubscribe();
  this.orderplacedflag = 0;
  this.razorpayorderplacedflag = 0;
  this.razorpayService.managestatus.next(0);
 }
}
